import { ActionCommand, Shift } from '@nextforce/api'
import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { UserShiftsScreenProps } from 'home/stack/types'
import React, { useCallback, useLayoutEffect } from 'react'
import { errorAlert } from 'shared/alerts'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { useCrewShifts } from 'shifts/queries/crew'
import { usePerformShiftAction } from 'shifts/queries/perform_action'
import { CrewShiftsView } from './view'

export function CrewShiftsScreen({ navigation, route }: UserShiftsScreenProps) {
  const query = useCrewShifts(route.params.uri)
  const { handleNavigation } = useRoutingContext()

  useLayoutEffect(() => {
    if (query.data?.title) {
      showHeaderTitle(navigation, query.data?.title)
    }
  }, [navigation, query.data?.title])

  const shiftMutation = usePerformShiftAction()

  const onSelectShift = useCallback(
    async (shift: Shift, command: ActionCommand) => {
      if (!command.action) {
        return
      }
      try {
        const res = await shiftMutation.mutateAsync({
          ...command.action,
          params: { ...command.action.params, to_shift_id: shift.id },
        })
        if (res) {
          handleNavigation({
            routeName: 'swap_cover_shift',
            routeParams: { shiftData: res },
          })
        }
      } catch (err: any) {
        errorAlert(err, t('swapShiftErrorTitle'))
      }
    },
    [shiftMutation, handleNavigation]
  )

  const onBack = useCallback(async () => {
    navigation.goBack()
  }, [navigation])

  return (
    <StatusBoundary isLoading={query.isLoading} error={query.error}>
      <CrewShiftsView
        {...{
          shifts: query.data?.shifts,
          onSelectShift,
          onBack,
          command: route.params.command,
        }}
      />
    </StatusBoundary>
  )
}
